import {Text} from '@mantine/core';
import React, {useEffect} from 'react';

import {CodonTranslationTable} from 'biojs/BioConstants';
import {GeneticCodeData} from 'biojs/Codons';
import geneticCodesDNA from 'data/geneticCodesDNA.json';
import {maybeGetValueFromConfig} from 'pipelines/generalized-step-config-editor/step-config-settings/StepConfigSettingsUtils';
import {CustomComponentEditorProps} from 'pipelines/generalized-step-config-editor/StepConfigEditorTypes';

export const STANDARD_GENETIC_CODE = CodonTranslationTable.STANDARD;

function getStandardGeneticCodeLabel(): string {
  const {name, number} = geneticCodesDNA[STANDARD_GENETIC_CODE] as GeneticCodeData;
  return `${number}. ${name}`;
}

export default function GeneticCodeDisplayEditor({
  config,
  onChangeConfig,
}: CustomComponentEditorProps): JSX.Element {
  const configuredGeneticCode =
    (maybeGetValueFromConfig(config, ['geneticCode']) as string | null | undefined) ?? null;

  useEffect(() => {
    if (configuredGeneticCode !== STANDARD_GENETIC_CODE) {
      onChangeConfig(config, ['geneticCode'], STANDARD_GENETIC_CODE);
    }
  }, [config, configuredGeneticCode, onChangeConfig]);

  return (
    <Text fz="sm" c="dark">
      {getStandardGeneticCodeLabel()}
    </Text>
  );
}
